import React, { useRef, useState, useEffect } from "react";
import { Image } from "react-bootstrap";
import classes from "./ProviderMaps.module.css";
import avatar from "../../../assets/images/avatar.svg";
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
  position: "absolute",
  left: "0",
  top: "auto",
  border: "1px solid #cbcbcb",
};

const ProviderMaps = (props) => {
  // let mapRef;
  const { onClick, markers, view } = { ...props };

  const variationMarker = useRef(null);
  console.log("props.markers", props.markers);
  // let center = {
  //   lat: 41.91,
  //   lng: -88.81,
  // }
  const mapRef = useRef(null);
  const [position, setPosition] = useState({
    lat: markers[0].latitude,
    lng: markers[0].longitude,
  });
  const [infoWindowIndex, setInfoWindowIndex] = useState(0);
  const optionsForMaps = {
    // disableDefaultUI: true,
    zoomControl: true,
  };
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  const handleCenter = () => {
    if (!mapRef.current) return;
    const newPos = mapRef.current.getCenter().toJSON();
    setPosition(newPos);
  };

  useEffect(() => {
    console.log("useEffect of provider maps");
    variationMarker.current = props.markers.map((marker) => {
      if (marker.latitude && marker.longitude) {
        let variation = (Math.floor(Math.random() * 10) - 0.5) / 1500;
        let lat = marker.latitude + variation;
        let lng = marker.longitude + variation;
        return { lat: lat, lng: lng };
      }
      return { lat: null, lng: null };
    });
  }, [props.markers]);

  useEffect(() => {
    if (props.addresses && props.addresses.length > 0) {
      variationMarker.current = props.addresses.map((address) => {
        if (address.latitude && address.longitude) {
          let variation = (Math.floor(Math.random() * 10) - 0.5) / 1500;
          let lat = address.latitude + variation;
          let lng = address.longitude + variation;
          setPosition({ lat: lat, lng: lng });
          return { lat: lat, lng: lng };
        }
        return { lat: null, lng: null };
      });
    }
  }, [props.addresses]);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
  });
  const [selected, setSelected] = React.useState(null);

  if (loadError) return <div>"Error loading maps"</div>;
  if (!isLoaded) return <div>"Loading Maps"</div>;

  console.log(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);

  let markerDisplay;
  if (props.markers) {
    markerDisplay =
      props.markers &&
      props.markers.map((marker, index) => {
        if (marker.latitude && marker.longitude) {
          // let variation = (Math.floor(Math.random() * 10) - 0.5) / 1500
          // let lat = marker.latitude + variation
          // let lng = marker.longitude + variation
          // let experienceScore = 0;
          // if (marker["experienceScore"] &&
          //   marker["experienceScore"][0] &&
          //   marker["experienceScore"][0]["label"].toLowerCase().match(/experience score/g)) {
          //   experienceScore = marker["experienceScore"][0]["value"];
          // } else if (marker["totalExperienceScore"]) {
          //   experienceScore = marker["totalExperienceScore"]
          // }
          if (marker["isContracted"]) {
            return (
              <Marker
                key={marker["providerId"]}
                position={{
                  lat: variationMarker.current[index].lat,
                  lng: variationMarker.current[index].lng,
                }}
                icon={{
                  url: require("../../../assets/images/pin-doc-approved.svg"),
                  scaledSize: new window.google.maps.Size(30, 30),
                  origin: new window.google.maps.Point(0, 0),
                  anchor: new window.google.maps.Point(15, 15),
                }}
                onClick={() => {
                  if (selected === null) {
                    setInfoWindowIndex(index);
                    setSelected(marker);
                  } else {
                    setSelected(null);
                    setInfoWindowIndex(0);
                  }
                }}
                // clusterer={clusterer}
              />
            );
          } else {
            return (
              <Marker
                key={marker["providerId"]}
                position={{
                  lat: variationMarker.current[index].lat,
                  lng: variationMarker.current[index].lng,
                }}
                icon={{
                  url: require("../../../assets/images/pin-doc.svg"),
                  scaledSize: new window.google.maps.Size(30, 30),
                  origin: new window.google.maps.Point(0, 0),
                  anchor: new window.google.maps.Point(15, 15),
                }}
                onClick={() => {
                  console.log(selected);
                  if (selected === null) {
                    setInfoWindowIndex(index);
                    setSelected(marker);
                  } else {
                    setSelected(null);
                    setInfoWindowIndex(0);
                  }
                }}
                // clusterer={clusterer}
              />
            );
          }
        }
        return null;
      });
  }

  return (
    <div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        zoom={12}
        options={optionsForMaps}
        onLoad={onMapLoad}
        onDragEnd={handleCenter}
        center={position}
        id="map"
      >
        {markerDisplay}

        {selected ? (
          <InfoWindow
            position={{
              lat: variationMarker.current[infoWindowIndex].lat,
              lng: variationMarker.current[infoWindowIndex].lng,
            }}
            onCloseClick={() => {
              setSelected(null);
              setInfoWindowIndex(0);
            }}
          >
            <div>
              {/* {selected && panTo({ lat: selected.latitude, lng: selected.latitude })} */}
              {/* <FindProviderResultItem
            provider={selected}
            onClick={onClick}
            style={{ width: "100%", padding: "0", margin: "0" }}
          /> */}
              <div
                className={classes.cardMaps}
                onClick={() =>
                  onClick(
                    selected["providerId"],
                    selected["npi"],
                    selected["distance"],
                    selected["postalCode"],
                    selected["orgDistance"]
                  )
                }
              >
                <div className={classes.cardsInfo}>
                  <Image src={avatar} alt="avatar" className={classes.oval} />
                  <div className={classes.cardDetails}>
                    <h4
                      className={
                        view === "details"
                          ? classes.cardTitleCursor
                          : classes.cardTitle
                      }
                    >
                      {selected.providerName}
                    </h4>
                    <span
                      className={
                        view === "details"
                          ? classes.cardSubTitleCursor
                          : classes.cardSubTitle
                      }
                    >
                      {selected.providerEntityType}
                    </span>
                    <span
                      className={
                        view === "details"
                          ? classes.cardSubTitleCursor
                          : classes.cardSubTitle
                      }
                    >{`${selected.providerType}-${selected.specialty}`}</span>
                  </div>
                </div>
              </div>
            </div>
          </InfoWindow>
        ) : null}
      </GoogleMap>
    </div>
  );
};

export default ProviderMaps;
